import enCompanyEmployees from './en';
import ruCompanyEmployees from './ru';

export default {
  en: {
    ...enCompanyEmployees,
  },
  ru: {
    ...ruCompanyEmployees,
  },
};
